import React from "react";
import { Box, Button, Card, CardContent, Stack, Typography } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { iconBadgeSx, panelCardSx } from "../../theme/surfaceStyles";

export default function StatCard({
    title,
    value,
    subtitle,
    icon: Icon,
    color = "primary",
    to,
    linkLabel = "Open",
    LinkComponent,
    onClick,
}) {
    const LinkWrap = LinkComponent || "div";

    return (
        <Card sx={(theme) => ({ height: "100%", ...panelCardSx(theme, { hover: true }) })}>
            <CardContent sx={{ py: 1.75, px: 2, "&:last-child": { pb: 1.75 } }}>
                <Stack direction="row" spacing={1.25} alignItems="flex-start">
                    {Icon ? (
                        <Box sx={(theme) => iconBadgeSx(theme, color)}>
                            <Icon sx={{ fontSize: 18 }} />
                        </Box>
                    ) : null}
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.06em" }}>
                            {title}
                        </Typography>
                        {value != null ? (
                            <Typography variant="h5" sx={{ fontWeight: 700, color: `${color}.main`, lineHeight: 1.2, mt: 0.25 }}>
                                {value}
                            </Typography>
                        ) : null}
                        {subtitle ? (
                            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.35, fontSize: "0.8125rem" }}>
                                {subtitle}
                            </Typography>
                        ) : null}
                    </Box>
                </Stack>
                {to || onClick ? (
                    <Button
                        component={to ? LinkWrap : "button"}
                        {...(to ? { to } : {})}
                        onClick={onClick}
                        size="small"
                        endIcon={<ArrowForwardIcon sx={{ fontSize: "0.9rem !important" }} />}
                        sx={{
                            mt: 1.25,
                            px: 0,
                            minHeight: 28,
                            fontSize: "0.8125rem",
                            color: "text.secondary",
                            "&:hover": { color: "primary.main", bgcolor: "transparent" },
                        }}
                    >
                        {linkLabel}
                    </Button>
                ) : null}
            </CardContent>
        </Card>
    );
}
